export const Switch = ({
  label = true,
  onChange,
  error,
  className,
  isSelected,
  isDisabled,
  isAlignCenter = false,
  isMarginbottomAdd = true,
  field,
}: any) => {
  return (
    <>
      {label && <label className='form-label'>{label}</label>}
      <div className='switch switch-icon text-center'>
        <div
          className={`form-check form-check-custom form-check-solid form-switch ${isAlignCenter && 'justify-content-center'} ${isMarginbottomAdd && 'mb-2'}`}
        >
          <input
            className={`${className} form-check-input`}
            type='checkbox'
            checked={isSelected}
            //   name='layout-builder[layout][aside][hoverable]'
            onChange={onChange}
            disabled={isDisabled ? isDisabled : false}
            {...field}
          />
          <span className="switch-text">{isSelected ? 'Active' : 'Inactive'}</span>
        </div>
      </div>
    </>
  )
}
